<div class="wrapper">
  <div class="header">
    <ng-content></ng-content>
  </div>
  <div class="body">
    <div *ngIf="survey?.building?.block?.handoverMode" class="margin-bottom">
      <div class="sub-title-container">
        <span class="sub-title" i18n="@@survey.inside.validate.handover">Handover Mode</span>
      </div>
      <div class="handover-text">
        <p i18n="@@survey.inside.validate.handover.text">This Building is currently in handover mode, any changes to the survey won't be pushed to back-end systems.</p>
      </div>
    </div>
    <div *ngIf="survey?.hasFailedValidateSurvey" class="margin-bottom">
      <div class="sub-title-container error">
        <span class="sub-title" i18n="@@survey.outside.validate.error">Error during validation</span>
      </div>
      <div class="error-text">
        <p i18n="@@survey.outside.validate.error.text">An occured has occured while synchronizing this Survey to the back-end systems.</p>
      </div>
      <div class="btn-group inline">
        <button
          class="btn-error"
          (click)="navigateToCommand()"
          i18n="@@survey.outside.validate.button.details"
        >
          View details
        </button>
      </div>
    </div>
    <div *ngIf="survey?.hasOngoingValidateSurvey" class="margin-bottom">
      <div class="sub-title-container error">
        <span class="sub-title" i18n="@@survey.outside.validate.error">Ongoing validation</span>
      </div>
      <div class="error-text">
        <p i18n="@@survey.outside.validate.error.text">The syncronization with the back end systems is still ongoing.</p>
      </div>
    </div>
    <div *ngIf="survey?.hasSucceededValidateSurvey" class="margin-bottom">
      <div class="sub-title-container error">
        <span class="sub-title" i18n="@@survey.outside.validate.error">Scyncronization Succesfull</span>
      </div>
    </div>
    <div class="sub-title-container">
      <span class="sub-title" i18n="@@general.remarks">Remarks</span>
    </div>
    <div style="margin-bottom: 1rem">
      <div class="textarea-container">
        <textarea
          class="remarks"
          placeholder="add validation remarks..."
          [(ngModel)]="remarks"
          (ngModelChange)="remarkChanged($event)"
        ></textarea>
      </div>
    </div>
    <div class="sub-title-container coordinates">
      <span class="sub-title" i18n="@@general.coordinates">COORDINATES</span>
    </div>
    <div style="padding-left: 2rem">
      <!-- <div style="padding-left: 2rem;" class="row" *ngIf="!survey?.building?.lomKey"> -->
      <div style="gap: 3rem" class="d-flex" [formGroup]="coordFormGroup">
        <div class="d-flex align-items-center">
          <span style="margin-right: 1rem">X</span>
          <input
            type="number"
            formControlName="x"
            class="form-control"
            [attr.disabled]="!this.isAuthCanWrite ? '' : null"
            #xCoord
          />
        </div>
        <div class="d-flex align-items-center">
          <span style="margin-right: 1rem">Y</span>
          <input
            type="number"
            formControlName="y"
            class="form-control"
            [attr.disabled]="!this.isAuthCanWrite ? '' : null"
            #yCoord
          />
        </div>
        <span>
          <img
            src="{{
              coordsValidated
                ? 'assets/Keen-Wise_validated.svg'
                : 'assets/Keen-Wise_validate.svg'
            }}"
            [class.clickable]="this.isAuthCanWrite"
            (click)="validateCoordinates()"
          />
        </span>
      </div>
    </div>
    <div class="btn-group">
      <button
        class="btn-validate"
        [class.disabled]="
          !coordsValidated || disableValidate || !survey.canValidateSurvey
        "
        (click)="onValidate()"
        i18n="@@general.validate"
      >
        Validate
      </button>
      <button
        class="btn-reject"
        (click)="onReject()"
        [class.disabled]="isSurveyBlockedByOngoingSync"
        i18n="@@survey.inside.validate.button.back"
      >
        Back to ongoing
      </button>
    </div>
  </div>
</div>
